
export function resolveHeaderMediaMimeType(file: File): string {
  const mime = String(file.type || "").trim().toLowerCase();
  if (mime) return mime;

  const name = file.name.toLowerCase();
  if (name.endsWith(".png")) return "image/png";
  if (name.endsWith(".jpg") || name.endsWith(".jpeg")) return "image/jpeg";
  if (name.endsWith(".mp4")) return "video/mp4";
  if (name.endsWith(".pdf")) return "application/pdf";
  return "application/octet-stream";
}

function asNonEmptyString(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed || null;
}

export function extractResumableUploadHandle(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  const fromH = asNonEmptyString(envelope.h);
  if (fromH) return fromH;

  const data = envelope.data;
  if (data && typeof data === "object") {
    return extractResumableUploadHandle(data);
  }

  return null;
}

export function extractResumableUploadSessionId(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  const directId = asNonEmptyString(envelope.id);
  if (directId && directId.startsWith("upload:")) return directId;

  const data = envelope.data;
  if (data && typeof data === "object") {
    return extractResumableUploadSessionId(data);
  }

  return null;
}

export function extractGraphApiErrorMessage(raw: unknown): string | null {
  if (!raw || typeof raw !== "object") return null;
  const envelope = raw as Record<string, unknown>;

  const error = envelope.error;
  if (error && typeof error === "object") {
    const message = (error as Record<string, unknown>).message;
    if (typeof message === "string" && message.trim()) return message.trim();
  }

  if (typeof envelope.message === "string" && envelope.message.trim()) {
    return envelope.message.trim();
  }

  return null;
}
